import React, { useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import { useTheme } from '@material-ui/core/styles';
import { useDispatch, useSelector } from "react-redux";
import { useSetState } from "Helpers/Hooks";
import MuiIconButton from "Components/MuiIconButton/MuiIconButton";
import DialogContent from "@material-ui/core/DialogContent";
import Input from "Components/Input/Input";
import Grid from "@material-ui/core/Grid";
import Translator from "Languages/Utility/Translator";
import { UpdateBrandName, editBazshoName, getAllYaragh } from "Stores/actions";
import { read } from "Helpers/LocalStorage";
import showNotify from "Helpers/Notify";
import * as R from "ramda";
import MuiButton from "Components/MuiButton/MuiButton";
import {DialogActions} from "@material-ui/core";
import { useTranslation } from 'react-i18next';
import BackDropLoading from "Components/BackDropLoading/BackDropLoading";
import * as Icons from 'react-bootstrap-icons';

export default function EditBazsho({reGetOnBack}) {
  const { direction } = useTheme();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [formValid, setFormValid] = useState({});
  const [checkValid, setCheckValid] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [change, setChange] = useState(false);
  const [loading, setLoading] = useState(false);
  const {
    selectedBazsho,
    bazshoList,
    selectedBrandYaragh,
  } = useSelector((state) => ({
    selectedBazsho: state.yaragh.selectedBazsho,
    bazshoList: state.yaragh.bazshoList,
    selectedBrandYaragh: state.yaragh.selectedBrandYaragh,
  }));
  const [controls, setControls] = useSetState({
    bazshoName: {
      type: "text",
      value: "",
      validation: {
        required: true,
      }
    },
  });

  const handleDialog = () => {
    setOpenDialog(!openDialog);
  }

  const onEnter = () => {
    onClear();
  }

  const onClear = () => {
    setCheckValid(false);
    setFormValid({ bazshoName: true });
    setControls({ bazshoName: { value: selectedBazsho.Name } });
  }

  const setValue = (name, value, validation) => {
    setControls({ [name]: { value: value } });
    setFormValid((prev) => ({ ...prev, [name]: validation }));
    setChange(true);
  }

  const onFinish = async (e) => {
    e.preventDefault();
    setLoading(true);
    if(change) {
      if (
        !R.isEmpty(formValid) &&
        Object.values(formValid).every((item) => item === true)
      ) {
        const { bazshoName } = controls;
        try {
          const data = {
            Id: selectedBazsho.Id,
            KeyGroup: read("groupKey"),
            KeyUser: read("userKey"),
            Name: bazshoName.value,
            StypePop: selectedBazsho.IdStypePopFitting
          };
          await dispatch(editBazshoName(data));
          let selectedIndex = -1;
          bazshoList.map((item, index) => {
            if(item.Id === selectedBazsho.Id) {
              selectedIndex = index;
            }
          })
          await reGetOnBack(false, selectedIndex)
        } catch (e) {
          showNotify({
            text: t('correctFormDataRequired'),
            customClass: "error",
          });
        }
        handleDialog();
      } else {
        setCheckValid(true);
      }
    } else {
      handleDialog();
    }
    setLoading(false);
  }

  return (
    <>
      <BackDropLoading loading={loading} />
      <MuiIconButton
        title={<Translator id={"editBazshoFitting"}/>}
        icon={<Icons.Pencil size={17}/>}
        className="fix-size"
        onClick={handleDialog}
      />
      <Dialog
        dir={direction}
        open={openDialog}
        TransitionProps={{onEnter: onEnter}}
        onClose={handleDialog}
        fullWidth
        maxWidth="xs"
      >
        <form onSubmit={onFinish}>
          <div className="dialogHeader">
            <p> {<Translator id="editBazshoFitting" />}</p>
          </div>
          <DialogContent>
            <Grid container className="mt-1">
              {Object.keys(controls).map((key, index) => {
                return (
                  <Grid item xs={12} key={key + index}>
                    {controls[key].type === "text" && (
                      <Input
                        loading={loading}
                        setValue={setValue.bind(this)}
                        name={key}
                        validation={controls[key].validation}
                        label={<Translator id={key} />}
                        placeholder={t(key)}
                        type="text"
                        checkValid={checkValid}
                        value={controls[key].value}
                      />
                    )}
                  </Grid>
                );
              })}
            </Grid>
          </DialogContent>
          <DialogActions>
            <MuiButton
                color="primary"
                type="submit"
                title={<Translator id="button_save" />}
            />
            <MuiButton
                onClick={handleDialog}
                title={<Translator id="enseraf" />}
            />
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
}

